import { AreaStatus } from '../enums/AreaStatus';
import { AreaType } from '../enums/AreaType';
import { Media } from './Media';
import { RoomBlock } from './RoomBlock';

export interface Area {
  id: string;
  name: string;
  short_name: string;
  type: AreaType;
  status: AreaStatus;
  /** Read-only: Inactive when `status` is Inactive or today is outside the available dates (PAUL-3771). */
  display_status?: AreaStatus;
  capacity: number;
  time_gap_in_minutes?: number;
  shop_id: string;
  shop_name?: string;
  screen_number: string;
  available_from: string;
  available_to: string;
  screen_width: number;
  screen_id?: string;
  introduction_time_in_minutes?: number;
  break_time_in_minutes?: number;
  has_movie_breaks: boolean;
  has_seats: boolean;
  disable_assigned_seating: boolean;
  seat_type_limits: { id: string; limit: number; seat_type_id: string }[];
  excluded_time_ranges: RoomBlock[];
  plans: AreaPlan[];
  seat_type_seats: SeatTypeSeats[];
  isSelected?: boolean;
}

export interface AreaPlan {
  id: string;
  plan_id: string;
  theme: AreaPlanTheme;
  media: Media;
}

export enum AreaPlanTheme {
  Dark = 0,
  Light = 1,
}

export interface SeatTypeSeats {
  seat_import_ids: string[];
  seat_type_id: string;
}
